"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.prepareLocalesUrl = exports.languageMapper = exports.getLanguageKey = exports.specificLanguages = exports.getLocaleFromLanguage = exports.pseudolocalizationConfiguration = void 0;

var _constants = require("./constants");

// localStorage API might be unavailable - ex. session view with third party cookies disabled
var safeLocalStorageGet = function safeLocalStorageGet(key) {
  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  try {
    return window.localStorage.getItem(key);
  } catch (err) {
    return defaultValue;
  }
};

var pseudolocalizationConfiguration = function pseudolocalizationConfiguration() {
  var lettersMultiplier = safeLocalStorageGet('PD_PSEUDOLOCALIZATION', null);
  return lettersMultiplier ? parseInt(lettersMultiplier, 10) : null;
};

exports.pseudolocalizationConfiguration = pseudolocalizationConfiguration;

var getLocaleFromLanguage = function getLocaleFromLanguage() {
  var language = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return language.slice(0, 2);
};

exports.getLocaleFromLanguage = getLocaleFromLanguage;
var specificLanguages = ['en-US', 'pt-BR'];
exports.specificLanguages = specificLanguages;

var getLanguageKey = function getLanguageKey(language) {
  return specificLanguages.includes(language) ? language : getLocaleFromLanguage(language);
};

exports.getLanguageKey = getLanguageKey;

var languageMapper = function languageMapper(language) {
  var code = getLocaleFromLanguage(language);
  var localeByCode = Object.keys(_constants.LANGUAGES_MAP).find(function (key) {
    return key.startsWith(code);
  });
  return localeByCode || language;
};
/**
 * Method that prepares translation folder path for environment
 * @param resourceUrl common url to resources (typically, S3/CDN)
 * @param environment environment name (live/stgXX etc.)
 * @returns {string}
 */


exports.languageMapper = languageMapper;

var prepareLocalesUrl = function prepareLocalesUrl(resourceUrl, environment) {
  if (!environment || _constants.SPECIAL_ENVIRONMENTS.includes(environment)) {
    return "".concat(resourceUrl, "locales");
  }

  return "".concat(resourceUrl).concat(environment, "/locales");
};

exports.prepareLocalesUrl = prepareLocalesUrl;